import { render } from "./AppIconButton.vue?vue&type=template&id=79ba299a&scoped=true"
import script from "./AppIconButton.vue?vue&type=script&lang=js"
export * from "./AppIconButton.vue?vue&type=script&lang=js"

import "./AppIconButton.vue?vue&type=style&index=0&id=79ba299a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ba299a"]])

export default __exports__